<template>
  <div class="px-6 py-2">
    <v-tabs v-model="tab">
      <v-tab>Básico</v-tab>
      <v-tab>Sitemap</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>

        <v-row class="" style="width: 100vw">
          <v-col cols="12" md="12" lg="12" xl="12">
            <v-card elevation="0" class="pa-4" color="" tile>
              <v-row class="justify-space-between">
                <v-col cols="12" md="6">
                  <v-card class="d-flex flex-column" elevation="0">
                    <v-card-text>
                      <v-img class="mb-4" width="560" max-width="120"
                        src="https://tmt-s3-v2.s3.amazonaws.com/public/seo_icon.svg"></v-img>
                      <div class="d-flex flex-column mb-8">
                        <span class="font-weight-bold headline">{{
                          $t("marketing.SEO.description.title")
                        }}</span>
                        <span class="body-1">{{
                          $t("marketing.SEO.description.p1")
                        }}</span>
                      </div>
                      <span class="body-1">{{
                        $t("marketing.SEO.description.p2")
                      }}</span>
                    </v-card-text>
                  </v-card>
                  <v-card elevation="0">
                    <v-card-text>


                      <template>
                        <v-dialog v-model="googleDialog" width="768" max-width="768">
                          <template v-slot:activator="{ on, attrs }">
                            <div class="d-flex">
                              <v-btn elevation="0" color="primary" dark v-bind="attrs" v-on="on">
                                {{ $t('marketing.SEO.description.serpBtn') }}<v-icon
                                  class="ml-2">mdi-monitor-eye</v-icon>
                              </v-btn>
                              <v-spacer></v-spacer>
                            </div>
                          </template>
                          <GoogleSearch :config="{
                            title: form.title,
                            description: form.description,
                            keywords: form.allKeywords,
                            link: selectedStore.url,
                            logo: selectedStore.logo,
                          }">
                          </GoogleSearch>
                          <v-divider></v-divider>
                        </v-dialog>
                      </template>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-divider vertical></v-divider>
                <v-col cols="12" md="6">
                  <form>
                    <div class="d-flex flex-column mt-4">
                      <v-row class="justify-space-around">
                        <v-col cols="12" md="10">
                          <label>Favicon</label>
                          <Upload :target="`/public/${selectedStore.id}/favicon`" :sample="true" :label="'Favicon'"
                            :unique="true" @set-upload="form.faviconOriginal = $event" :snap="form.faviconOriginal"
                            mime="image/png">
                          </Upload>
                          <div class="-favicon">
                            <div class="img-container">

                              <img src="" width="300" id="toCrop">
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="12" md="10" class="no-padding-y">
                          <div class="d-flex align-baseline">
                            <v-text-field counter="70" :hint="$t('marketing.SEO.form.titleHint')" persistent-hint
                              :disabled="disableTitle" :label="$t('marketing.SEO.form.title')" class=""
                              v-model="form.title" filled required></v-text-field>
                            <v-btn class="ml-8" icon small
                              @click="editItem('title')"><v-icon>mdi-pencil-outline</v-icon></v-btn>
                          </div>
                        </v-col>
                      </v-row>

                      <v-row class="justify-space-around">
                        <v-col cols="12" md="10" class="no-padding-y">
                          <div class="d-flex align-baseline">
                            <v-text-field :hint="$t('marketing.SEO.form.subtitleHint')" persistent-hint
                              :disabled="disableSubtitle" :label="$t('marketing.SEO.form.subtitle')" filled
                              v-model="form.subtitle" :abel="$t('marketing.SEO.form.subtitle')"></v-text-field>
                            <v-btn class="ml-8" icon small
                              @click="editItem('subtitle')"><v-icon>mdi-pencil-outline</v-icon></v-btn>
                          </div>
                        </v-col>
                      </v-row>

                      <v-row class="justify-space-around">
                        <v-col cols="12" md="10" class="no-padding-y">
                          <div class="d-flex align-baseline">
                            <v-textarea height="120" style="overflow-y: auto"
                              :hint="$t('marketing.SEO.form.descriptHint')" persistent-hint
                              :disabled="disableDescription" :label="$t('marketing.SEO.form.description')" filled
                              v-model="form.description"></v-textarea>
                            <v-btn class="ml-8" icon small
                              @click="editItem('description')"><v-icon>mdi-pencil-outline</v-icon></v-btn>
                          </div>
                        </v-col>
                      </v-row>

                      <v-row class="justify-space-around no-padding-y">
                        <v-col cols="12" md="10">
                          <div class="d-flex align-baseline">
                            <div class="">
                              <v-combobox :label="$t('marketing.SEO.form.keywords')"
                                :hint="$t('marketing.SEO.form.keywordsHint')" persistent-hint
                                :disabled="disableKeywords" v-model="form.allKeywords" :items="form.allKeywords"
                                multiple chips>
                                <!-- <template #selection="{ item, attrs, on }">
                              <v-chip
                                v-bind="attrs"
                                v-on="on"
                                close
                                @click:close="removeKeyword(item)"
                              >
                                {{ item }}
                              </v-chip>
                            </template> -->
                              </v-combobox>
                            </div>
                            <v-btn class="ml-8" icon small
                              @click="editItem('keywords')"><v-icon>mdi-plus</v-icon></v-btn>
                          </div>
                        </v-col>
                      </v-row>

                      <v-row class="justify-space-around no-padding-y">
                        <v-col cols="12" md="10" class="" style="padding-top: 2px">
                          <div class="d-flex flex-column">
                            <span class="subtitle-2" :class="`${progressBar.colorBar}--text`">{{ progressBar.text
                              }}</span>
                            <div class="d-flex align-center mt-2">
                              <v-progress-linear :color="progressBar.colorBar" :value="progress"
                                height="5"></v-progress-linear>
                              <v-icon :color="progressBar.colorBar">{{
                                progressBar.icon
                              }}</v-icon>
                            </div>
                          </div>
                          <v-btn float v-if="showBtn == true" color="#4CAF50" :loading="loading"
                            class="mr-4 white--text btn mt-4" @click="save(formStore)">
                            {{ this.$t("common.save") }}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </div>
                  </form>
                </v-col>
              </v-row>
              <v-snackbar style="top: 70px" top right v-model="success.show" color="green">
                <span v-html="success.text"></span>
                <v-btn icon @click="success.show = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-snackbar>
              <v-snackbar style="top: 70px" top right v-model="errors.show" color="red">
                <span v-html="errors.text"></span>
                <v-btn icon @click="errors.show = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-snackbar>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item>
        <SiteMaps></SiteMaps>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
//import UserName from "./UserName.vue";
import useVuelidate from "@vuelidate/core";
import { required, minLength, maxLength, email } from "@vuelidate/validators";
import { mapGetters, mapActions, mapState } from "vuex";
import { isEqual } from "lodash";
import GoogleSearch from "@/interface/GoogleSearch.vue";
import SiteMaps from "./SiteMaps.vue";
import Upload from "@/interface/FileUpload.vue";

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  name: "SeoForm",
  components: {
    GoogleSearch,
    SiteMaps,
    Upload
  },
  validations() {
    return {
      form: {
        title: { required, minLength: minLength(3), maxLength: maxLength(100) },
        subtitle: { required, email },
        descrition: { required, minLength: minLength(8) },
        keywords: { required, minLength: minLength(8) },

      },
    };
  },

  data() {
    return {
      tab: 0,
      googleDialog: false,
      showBtn: false,
      disableTitle: true,
      disableSubtitle: true,
      disableDescription: true,
      disableKeywords: true,

      seoTips: [
        {
          seoTitle: "Título",
          seoDescript:
            "O título da página deve ser claro e conciso, e deve conter a palavra-chave principal da página. É recomendável que o título tenha no máximo 70 caracteres.",
        },
        {
          seoTitle: "Subtítulo",
          seoDescript:
            "O subtítulo é opcional, mas pode ajudar a dar mais contexto para o título. Se for utilizado, deve ser breve e estar relacionado ao tema da página.",
        },
        {
          seoTitle: "Descrição",
          seoDescript:
            "A descrição deve ser uma breve explicação do conteúdo da página. Deve conter a palavra-chave principal, e ter no máximo 160 caracteres. É importante que a descrição seja única para cada página.",
        },
        {
          seoTitle: "Keywords",
          seoDescript:
            "As palavras-chave devem ser relacionadas ao conteúdo da página, e devem ser separadas por vírgulas. É recomendável utilizar de 5 a 10 palavras-chave por página. No entanto, é importante evitar o excesso de palavras-chave, o que pode ser interpretado como spam pelos motores de busca.",
        },
      ],
      form: {
        title: "",
        subtitle: "",
        description: "",
        allKeywords: [],
        faviconOriginal: []
      },
      loading: false,
      formStore: {},
      success: {
        text: "",
        show: false,
      },
      previousForm: {},

      errors: {
        text: "",
        show: false,
      },
      errorsOldPassword: [],
    };
  },

  computed: {
    ...mapState("groupStores", ["selectedStore"]),

    progressBar() {
      switch (true) {
        case this.progress < 50:
          return {
            icon: "mdi-speedometer-slow",
            colorBar: "red",
            text: this.$t("marketing.SEO.form.weakSeo"),
          };
        case this.progress >= 50 && this.progress < 100:
          return {
            icon: "mdi-speedometer-medium",
            colorBar: "orange",
            text: this.$t("marketing.SEO.form.mediumSeo"),
          };
        case this.progress === 100:
          return {
            icon: "mdi-speedometer",
            colorBar: "green",
            text: this.$t("marketing.SEO.form.strongSeo"),
          };
        default:
          return "";
      }
    },

    progress() {
      const camposPreenchidos = Object.values(this.form).filter(
        (valor) => !!valor
      ).length;
      return camposPreenchidos * 25;
    },
    disabledBtn() {
      return this.v$.$invalid;
    },

    formClone() {
      return JSON.stringify(this.form);
    },

    titleErrors() {
      const errors = [];
      if (!this.v$.form.title.$dirty) return errors;
      this.v$.form.title.minLength.$invalid &&
        errors.push(
          this.$t("accountSettings.personalData.err.minLengthName", {
            count: 3,
          })
        );
      this.v$.form.title.maxLength.$invalid &&
        errors.push(
          this.$t("accountSettings.personalData.err.maxLengthName", {
            count: 100,
          })
        );
      this.v$.form.title.required.$invalid &&
        errors.push(this.$t("accountSettings.personalData.err.name"));
      return errors;
    },
    subtitleErrors() {
      const errors = [];
      if (!this.v$.form.subtitle.$dirty) return errors;
      this.v$.form.subtitle.$invalid &&
        errors.push(this.$t("accountSettings.personalData.err.email"));
      this.v$.form.subtitle.required.$invalid &&
        errors.push(this.$t("accountSettings.personalData.err.requiredEmail"));
      return errors;
    },

    descriptionErrors() {
      const errors = [];
      if (!this.v$.form.phoneNumber.$dirty) return errors;
      this.v$.form.phoneNumber.required.$invalid &&
        errors.push(this.$t("accountSettings.personalData.err.requiredPhone"));
      return errors;
    },
    keywordsErrors() {
      const errors = [];
      if (!this.v$.form.phoneNumber.$dirty) return errors;
      this.v$.form.phoneNumber.required.$invalid &&
        errors.push(this.$t("accountSettings.personalData.err.requiredPhone"));
      return errors;
    },
  },

  mounted() {
    this.cloneStore();
  },
  watch: {
    'form.faviconOriginal': {
      deep: true,
      handler(f) {
        let r = f
        if (Array.isArray(f)) {
          r = f[0].url
        }
        const img = document.getElementById('toCrop');
        img.setAttribute('src', f)
        setTimeout(() => {
          const cropper = new Cropper(img, {
            dragMode: 'move',
            aspectRatio: 1 / 1,
            autoCropArea: 0.65,
            restore: false,
            guides: false,
            center: false,
            highlight: false,
            cropBoxMovable: true,
            cropBoxResizable: false,
            toggleDragModeOnDblclick: false,
          })
          console.log('cropper', cropper)
        }, 1000)
        // };
        // xhr.open('GET', url);
        // xhr.send();

        // Or inserted into an <img> element







      }
    },
    showBtn(nv) {
      if (nv == true) {
        window.scrollTo(0, document.body.scrollHeight);
      }

    },

    form: {
      handler(newVal) {
        if (!isEqual(newVal, this.formStore.seo)) {
          this.showBtn = true;
          console.log("Formulário alterado:", newVal);
        }
      },
      deep: true,
    },


  },
  methods: {
    ...mapActions("groupStores", ["setValueInStore", "saveStore"]),
    ...mapActions("snackbar", ["showSnack"]),

    editItem(item) {
      if (item == "title") {
        this.disableTitle = !this.disableTitle;
      }
      if (item == "subtitle") {
        this.disableSubtitle = !this.disableSubtitle;
      }
      if (item == "description") {
        this.disableDescription = !this.disableDescription;
      }
      if (item == "keywords") {
        this.disableKeywords = !this.disableKeywords;
      }
    },

    async cloneStore() {
      this.readyToEdit = false;
      let cloneStore = JSON.parse(JSON.stringify(this.selectedStore));
      await this.$set(this, "formStore", cloneStore);
      this.getCurrentForm();
      setTimeout(() => {
        this.readyToEdit = true;
      }, 200);
    },

    getCurrentForm() {
      this.form.title = this.selectedStore.seo.title;
      this.form.subtitle = this.selectedStore.seo.subtitle;
      this.form.description = this.selectedStore.seo.description;
      this.form.allKeywords = this.selectedStore.seo.allKeywords;
    },

    clear() {
      this.v$.$reset();
      this.name = "";
      this.email = "";
      this.select = null;
      this.checkbox = false;
    },

    save(form) {
      form.seo = this.form;
      this.processing = true;
      this.saveStore(form)
        .then(
          () => {
            console.log("SEOForm", form);
            //this.editing = false
            //this.processing = false
            //this.sucessSaved = true
          },
          (err) => {
            console.error("err", err);
          }
        )
        .then(() => {
          this.disableTitle = true;
          this.disableSubtitle = true;
          this.disableDescription = true;
          this.disableKeywords = true;
          this.showBtn = false;
          this.showSnack({
            text: this.$t("marketing.SEO.form.snackSave"),
            color: "success",
            timeout: 3800,
            icon: "mdi-check",
          });
          this.cloneStore();
        });
    },
  },
};
</script>
<style lang="scss">
.container {
  max-width: 100%;
}

.btn {
  width: 100%;
}

.no-padding-y {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.--flag {
  flex: 0 0 60px !important;
  max-width: 60px !important;

  .v-select__selection.v-select__selection--comma {
    display: none !important;
  }
}

.-favicon {
  .img-container {
    min-height: 497px;
    max-width: 497px;
    margin-bottom: 1rem;
    background-color: white;
    text-align: center;
    width: 100%;
  }

  .img-container>img {
    max-width: 100%;
  }

  img {
    vertical-align: middle;
    border-style: none;
  }
}
</style>
